const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgIconPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.93 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2e3a47;}")), /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Facturaci\xF3n"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.33,0h17.4a.43.43,0,0,1,.4.4V2.1a.4.4,0,0,1-.8,0V.8H.83V18.3h1.3a.4.4,0,1,1,0,.8H.43a.43.43,0,0,1-.4-.4V.3C-.07.2.13,0,.33,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.13,1.8h17.4a.43.43,0,0,1,.4.4V20.6a.43.43,0,0,1-.4.4H2.13a.43.43,0,0,1-.4-.4V2.2C1.63,2,1.83,1.8,2.13,1.8ZM19,2.6H2.53V20.2H19Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.85,9.33H7a1.45,1.45,0,0,1,1,.36,1.32,1.32,0,0,1,.39,1,1.41,1.41,0,0,1-.35,1A1.31,1.31,0,0,1,7,12.1H5.5v2H4.85ZM7.37,10a1.39,1.39,0,0,0-.59-.1H5.5v1.66H6.78a1.27,1.27,0,0,0,.71-.18.76.76,0,0,0,.27-.66A.73.73,0,0,0,7.37,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.27,9.33h1.92a1.8,1.8,0,0,1,1.52.7,2.65,2.65,0,0,1,.48,1.63A3.25,3.25,0,0,1,12.9,13a1.75,1.75,0,0,1-1.71,1.09H9.27Zm1.79,4.24a1.65,1.65,0,0,0,.54-.07,1.13,1.13,0,0,0,.6-.49,1.84,1.84,0,0,0,.27-.74,2.29,2.29,0,0,0,0-.5,2.32,2.32,0,0,0-.35-1.39,1.25,1.25,0,0,0-1.11-.49H9.93v3.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.14,9.33h3.33v.59H14.79v1.45h2.35V12H14.79v2.18h-.65Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdf);
export default __webpack_public_path__ + "static/media/icon_PDF.096870a120ea261072abdb9d51bb7ccb.svg";
export { ForwardRef as ReactComponent };